export default __webpack_public_path__ + "static/media/middleImage_2.241d936e.png";